module.exports = __webpack_public_path__ + "assets/interestamount.1f002294.svg";